import React from 'react'
import { ValidatedSelect } from '../system/forms/validated-input'
import breakpoints from '../../styles/breakpoints'
import styled from 'styled-components'
import FormGroup from '../system/forms/form-group'

export const NameFormGroup = styled(FormGroup)`
  grid-template-columns: 1fr;

  @media (min-width: ${breakpoints.lg}) {
    grid-template-columns: auto 1fr 1fr;
  }
`

const NamePrefixSelect = (props: any) => {
  return (
    <ValidatedSelect {...props}>
      <option value="" disabled>
        Choose...
      </option>
      <option value="MR">Mr.</option>
      <option value="MRS">Mrs.</option>
      <option value="MS">Ms.</option>
      <option value="DR">Dr.</option>
    </ValidatedSelect>
  )
}

export default NamePrefixSelect
